module.exports = __webpack_public_path__ + "img/sensitive.41528b8b.svg";